import script from "./InputErrorMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputErrorMessage.vue?vue&type=script&lang=ts&setup=true"

import "./InputErrorMessage.vue?vue&type=style&index=0&id=48b9b6c0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b9b6c0"]])

export default __exports__